import secureApi from "../services/secureApi";


export const getProfitReport = async (params = {}) => {
  const response = await secureApi.post("/admin/reports/profit", params);
  return response.data;
};

export const exportProfitReport = async (params = {}) => {
  return secureApi.post("/admin/reports/profit/export", params, {
    responseType: "blob",
  });
};

export const getTaxReport = async (params = {}) => {
  const response = await secureApi.post("/admin/reports/tax", params);
  return response.data;
};

export const exportTaxReport = async (params = {}) => {
  return secureApi.post("/admin/reports/tax/export", params, {
    responseType: "blob",
  });
};

export const getPaymentReport = async (params = {}) => {
  const response = await secureApi.post("/admin/reports/payments", params);
  return response.data;
};

export const exportPaymentReport = async (params = {}) => {
  return secureApi.post("/admin/reports/payments/export", params, {
    responseType: "blob",
  });
};

export const getCourierReport = async (params = {}) => {
  const response = await secureApi.post("/admin/reports/courier", params);

  return response.data;
};

export const exportCourierReport = async (params = {}) => {
  return secureApi.post("/admin/reports/courier/export", params, {
    responseType: "blob",
  });
};
